import {Component, Input} from '@angular/core';
import {MatIcon} from '@angular/material/icon';

@Component({
    selector: 'frog-video-processing',
    imports: [MatIcon],
    templateUrl: './video-processing.component.html',
    styleUrl: './video-processing.component.scss',
})
export class VideoProcessingComponent {
    @Input() assetName: string;
    @Input() uploaderName: string;
    @Input() failed = false;
}
